import React from "react";

export const Testimonial = ({ quote, author, role }) => (
    <figure className="card testimonial">
        <blockquote>“{quote}”</blockquote>
        <figcaption className="muted">— <span className="strong">{author}</span>, {role}</figcaption>
    </figure>
);
